import { PageShell } from "./page-shell";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/hooks/use-theme";
import { useAuth } from "@/hooks/use-auth";

export function PreferencesPage() {
  const { theme, setTheme } = useTheme();
  const { session } = useAuth();

  return (
    <PageShell title="Preferences" description="Personal display preferences. Only affect you.">
      <div className="space-y-5">
        <Section title="Identity">
          <dl className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
            <dt className="text-ink-muted">Name</dt>
            <dd>{session?.full_name || session?.username}</dd>
            <dt className="text-ink-muted">Username</dt>
            <dd className="font-mono">{session?.username}</dd>
            <dt className="text-ink-muted">Role</dt>
            <dd>{session?.role}</dd>
          </dl>
        </Section>

        <Section title="Appearance" hint="Pick how the admin renders. Persists per browser.">
          <div className="flex gap-2">
            <Button
              variant={theme === "light" ? "outline" : "ghost"}
              onClick={() => setTheme("light")}
              className={theme === "light" ? "bg-surface" : ""}
            >
              Light
            </Button>
            <Button
              variant={theme === "dark" ? "outline" : "ghost"}
              onClick={() => setTheme("dark")}
              className={theme === "dark" ? "bg-surface" : ""}
            >
              Dark
            </Button>
          </div>
        </Section>
      </div>
    </PageShell>
  );
}

function Section({ title, hint, children }: { title: string; hint?: string; children: React.ReactNode }) {
  return (
    <section className="rounded-lg border border-line bg-surface p-5">
      <h3 className="text-md font-semibold text-ink">{title}</h3>
      {hint && <p className="mt-1 text-sm text-ink-muted">{hint}</p>}
      <div className="mt-4">{children}</div>
    </section>
  );
}
